var React = require('react');

function Chart (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22 22H2","stroke":"auto","strokeWidth":"1.5","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M21 22V14.5C21 13.6716 20.3284 13 19.5 13H16.5C15.6716 13 15 13.6716 15 14.5V22","stroke":"auto","strokeWidth":"1.5","key":1}),React.createElement("path",{"d":"M15 22V5C15 3.58579 15 2.87868 14.5607 2.43934C14.1213 2 13.4142 2 12 2C10.5858 2 9.87868 2 9.43934 2.43934C9 2.87868 9 3.58579 9 5V22","stroke":"auto","strokeWidth":"1.5","key":2}),React.createElement("path",{"d":"M9 22V9.5C9 8.67157 8.32843 8 7.5 8H4.5C3.67157 8 3 8.67157 3 9.5V22","stroke":"auto","strokeWidth":"1.5","key":3})]);
}

Chart.defaultProps = {"width":"800px","height":"800px","stroke":"black","viewBox":"0 0 24 24","fill":"none"};

module.exports = Chart;

Chart.default = Chart;
